<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_1"></a><a id="page_2">Published in 1987 by</a></p><a id="page_2">
<p class="copyright1">Academy Chicago Publishers</p>
<p class="copyright2">425 North Michigan Avenue</p>
<p class="copyright2">Chicago, Illinois 60611</p>
<p class="copyright1">Copyright © Leo Bruce 1958</p>
<p class="copyright1">Printed and bound in the USA</p>
<p class="copyright1">No part of this book may be reproduced<br/>in any form without the express written<br/>permission of the publisher.</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright3">Bruce, Leo, 1903-1980.</p>
<p class="copyright4">Dead man’s shoes.</p>
<p class="copyright5">I. Title.</p>
<p class="copyright6">PR6005.R673D37    1987      823’.912      87-19370</p>
<p class="copyright6">ISBN 0-89733-272-5</p>
<p class="copyright6">ISBN 0-89733-271-7 (pbk.)</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Copyright.vue?8bd3480c